import { MemberDetailState } from "@erinfo/provider/src/store/models/memberDetail"
import { FC, useState } from "react"
import { Box, Typography, IconButton } from "@mui/material"
import { ChevronLeft, ChevronRight } from "@mui/icons-material"
import dayjs from "dayjs"
import { capitalize } from "lodash"
import * as attr from "@erinfo/data-schema/src/attribute"
import { getKeyFromCompositeId } from "@erinfo/data-schema/src/attribute"
import { getColor } from "@erinfo/brand-ui/src/storybook/other/forms/Disposition"
import { PhotoLocationMap } from "@erinfo/brand-ui/src/storybook/other/photo-location"

const DispositionRow = ({ label, value, fullOpacityValue }: any) => (
  <Typography component="span" sx={{ opacity: 0.9 }}>
    {label}:{" "}
    <Typography component="span" sx={{ opacity: fullOpacityValue ? 1 : 0.7 }}>
      {value}
    </Typography>
  </Typography>
)

export const Dispositions: FC<{
  user: MemberDetailState
}> = ({ user }) => {
  const [currDispositionIdx, setCurrDispositionIdx] = useState(0)
  const currDisposition = user?.recentMatches[currDispositionIdx]
  const triageColor = getColor(currDisposition?.[attr.nameTriageStatus])

  return (
    currDisposition && (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography>Incident History</Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() =>
                currDispositionIdx > 0 &&
                setCurrDispositionIdx(currDispositionIdx - 1)
              }
            >
              <ChevronLeft />
            </IconButton>
            <Typography>{`${currDispositionIdx + 1} of ${
              user.recentMatches.length
            }`}</Typography>
            <IconButton
              onClick={() =>
                currDispositionIdx < user?.recentMatches?.length - 1 &&
                setCurrDispositionIdx(currDispositionIdx + 1)
              }
            >
              <ChevronRight />
            </IconButton>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column">
          <Typography variant="h7">
            {currDisposition[attr.nameIncidentType] === "evacuation"
              ? "Evacuation Record"
              : "Mass Casualty Record"}
          </Typography>
          <DispositionRow
            label="Date/Time"
            value={dayjs(currDisposition.created).format("lll")}
          />
          <DispositionRow
            fullOpacityValue
            label="Photo Location"
            value={
              currDisposition[attr.nameLat] &&
              currDisposition[attr.nameLong] ? (
                <PhotoLocationMap
                  lat={currDisposition[attr.nameLat]}
                  long={currDisposition[attr.nameLong]}
                />
              ) : (
                ""
              )
            }
          />
          <DispositionRow
            label="Incident ID"
            value={currDisposition[attr.nameIncidentId]}
          />
          <DispositionRow
            label="Transport Unit"
            value={currDisposition[attr.nameTransportUnit]}
          />
          <DispositionRow
            label="Patient Destination"
            value={currDisposition[attr.namePatientDestination]}
          />
          <DispositionRow
            fullOpacityValue
            label="Triage Status"
            value={
              <Typography sx={{ color: triageColor }} component="span">
                ● {capitalize(currDisposition?.[attr.nameTriageStatus])}
              </Typography>
            }
          />
          {currDisposition[attr.nameIncidentType] === "evacuation" && (
            <>
              <DispositionRow
                label="Initial Location"
                value={currDisposition[attr.nameInitialLocation]}
              />
              <DispositionRow
                label="Evacuee Type"
                value={currDisposition[attr.nameEvacueeType]}
              />
              <DispositionRow
                label="Evacuation Status"
                value={currDisposition[attr.nameEvacuationStatus]}
              />
            </>
          )}

          <DispositionRow label="Organization" value={""} />
          <DispositionRow
            label="User ID"
            value={getKeyFromCompositeId(currDisposition.providerID)?.sk}
          />
        </Box>
      </Box>
    )
  )
}
